'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _ImaApi2 = require('./ImaApi');

var _ImaApi3 = _interopRequireDefault(_ImaApi2);

var _imaEvents = require('./imaEvents');

var _imaEvents2 = _interopRequireDefault(_imaEvents);

var _constants = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COMPANION_AD_SIZES = [{
  width: 300,
  height: 600
}, {
  width: 300,
  height: 250
}, {
  width: 728,
  height: 90
}];

var ImaPlayer = function (_ImaApi) {
  _inherits(ImaPlayer, _ImaApi);

  function ImaPlayer(google) {
    _classCallCheck(this, ImaPlayer);

    var _this = _possibleConstructorReturn(this, (ImaPlayer.__proto__ || Object.getPrototypeOf(ImaPlayer)).call(this, google));

    _this.adContainer = null;
    _this.adsManager = null;
    _this.imaVideoElement = null;
    _this.playerContainerElement = null;
    _this.ad = {};

    _this.onAdLoaded = _this.onAdLoaded.bind(_this);
    _this.onAdError = _this.onAdError.bind(_this);
    _this.onAdStarted = _this.onAdStarted.bind(_this);
    _this.onVolumeChanged = _this.onVolumeChanged.bind(_this);
    _this.onAdImpression = _this.onAdImpression.bind(_this);
    _this.getCompanionAds = _this.getCompanionAds.bind(_this);
    _this.onAdProgress = _this.onAdProgress.bind(_this);
    _this.onAdPaused = _this.onAdPaused.bind(_this);
    _this.onAdResumed = _this.onAdResumed.bind(_this);
    _this.onAdComplete = _this.onAdComplete.bind(_this);
    return _this;
  }

  /**
   * Method responsible for creating and inserting the video element that
   * the Google IMA Player SDK needs in order to perform ad playback. The
   * playerContainerElement that is specified by the playerContainerId must
   * be present in the DOM when this method is called.
   *
   * @param playerContainerId {string}: ID that indicates where the IMA Player
   *  video element should be inserted
   */


  _createClass(ImaPlayer, [{
    key: 'initialize',
    value: function initialize(playerContainerId) {
      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var imaVideo = global.document.getElementById(_constants.IMA_VIDEO_PLAYER_ID);
      var playerContainer = global.document.getElementById(playerContainerId);
      this.validateAndSetVolume(settings.volume);

      if (imaVideo && playerContainer) {
        this.imaVideoElement = imaVideo;
        this.playerContainerElement = playerContainer;
        return;
      }
      var imaVideoElement = global.document.createElement('video');
      imaVideoElement.setAttribute('id', _constants.IMA_VIDEO_PLAYER_ID);
      if (settings.isMobile) {
        imaVideoElement.setAttribute('playsinline', '');
      }
      playerContainer.appendChild(imaVideoElement);

      this.imaVideoElement = imaVideoElement;
      this.playerContainerElement = playerContainer;
    }

    /**
     * Method that allows the adContainer to be initialized independently from requesting the
     * ad tag. This is necessary for mobile browsers where the adContainer needs to be created
     * and initialized synchronously from a click handler.
     *
     * Documentation:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/autoplay
     *
     * Example for IMA initialization sequence inside click handler:
     *  https://github.com/googleads/videojs-ima/blob/master/examples/simple/ads.js
     */

  }, {
    key: 'preload',
    value: function preload() {
      try {
        if (!this.google || !this.google.ima) {
          this.google = global.google;
        }
        this.adContainer = this.getAdContainer(this.playerContainerElement, this.imaVideoElement);
      } catch (ex) {
        this.adContainer = null;
      }
    }

    /**
     * Private method that loads, sets and initializes the AdsManager so that it can be used
     * for ad playback.
     *
     * AdsManager.init():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.init
     *
     * @param url {string}: Ad request url
     * @returns {Promise<void>}
     */

  }, {
    key: '_load',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.google || !this.google.ima || !this.adContainer)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Google IMA SDK not initialized');

              case 2:
                _context.next = 4;
                return this.getAdsManager(url, this.adContainer, this.imaVideoElement);

              case 4:
                this.adsManager = _context.sent;

                this.adsManager.init(640, 480, this.google.ima.ViewMode.NORMAL);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _load(_x2) {
        return _ref.apply(this, arguments);
      }

      return _load;
    }()

    /**
     * Method to register event handlers for various Google IMA Ad Events, and to start the ad
     * that was loaded via the ImaPlayer.load() call.
     *
     * AdsManager.start():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.start
     *
     * AdEvent.Type:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdEvent.Type
     */

  }, {
    key: 'start',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
        var ima;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this._load(url);

              case 3:
                ima = (0, _get2.default)(this, 'google.ima');

                this.adsManager.addEventListener(ima.AdErrorEvent.Type.AD_ERROR, this.onAdError);
                this.adsManager.addEventListener(ima.AdEvent.Type.LOADED, this.onAdLoaded);
                this.adsManager.addEventListener(ima.AdEvent.Type.STARTED, this.onAdStarted);
                this.adsManager.addEventListener(ima.AdEvent.Type.STARTED, this.getCompanionAds);
                this.adsManager.addEventListener(ima.AdEvent.Type.VOLUME_CHANGED, this.onVolumeChanged);
                this.adsManager.addEventListener(ima.AdEvent.Type.AD_PROGRESS, this.onAdProgress);
                this.adsManager.addEventListener(ima.AdEvent.Type.IMPRESSION, this.onAdImpression);
                this.adsManager.addEventListener(ima.AdEvent.Type.PAUSED, this.onAdPaused);
                this.adsManager.addEventListener(ima.AdEvent.Type.RESUMED, this.onAdResumed);
                this.adsManager.addEventListener(ima.AdEvent.Type.COMPLETE, this.onAdComplete);
                this.adsManager.setVolume(this.imaPlayerVolume);
                this.adsManager.start();
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](0);

                this.onAdError(_context2.t0);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 18]]);
      }));

      function start(_x3) {
        return _ref2.apply(this, arguments);
      }

      return start;
    }()

    /**
     * Method to resume a previously paused ad.
     *
     * AdsManager.resume():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.resume
     */

  }, {
    key: 'resume',
    value: function resume() {
      if (!this.adsManager) {
        return;
      }
      this.adsManager.resume();
    }

    /**
     * Method to pause the currently playing ad.
     *
     * AdsManager.pause():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.pause
     */

  }, {
    key: 'pause',
    value: function pause() {
      if (!this.adsManager) {
        return;
      }
      this.adsManager.pause();
    }

    /**
     * Method to stop the currently playing ad.
     *
     * AdsManager.stop():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.stop
     */

  }, {
    key: 'stop',
    value: function stop() {
      if (!this.adsManager) {
        return;
      }
      this.adsManager.stop();
    }

    /**
     * Resizes the current ad. Makes use of the Google IMA SDK's ViewMode enum to determine whether to
     * use normal or fullscreen view mode. Hard-coding the viewMode param to NORMAL here since
     * we currently don't support fullscreen resizing on video ads.
     *
     * AdsManager.resize():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.resize
     *
     * ViewMode:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.ViewMode
     *
     * @param width {number}
     * @param height {number}
     */

  }, {
    key: 'resize',
    value: function resize(width, height) {
      if (!this.adsManager) {
        return;
      }
      this.adsManager.resize(width, height, this.google.ima.ViewMode.NORMAL);
    }

    /**
     * Method to set the volume of the current ad. The volume argument needs to be between 0 and 1.
     *
     * AdsManager.setVolume():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.setVolume
     *
     * @param volume {number}
     */

  }, {
    key: 'volume',
    value: function volume(_volume) {
      this.validateAndSetVolume(_volume);

      if (!this.adsManager) {
        return;
      }

      this.adsManager.setVolume(this.imaPlayerVolume);
    }

    /**
     * Method to return a valid value (0-1) for the IMA player volume
     *
     * @param volume {number}
     */

  }, {
    key: 'validateAndSetVolume',
    value: function validateAndSetVolume(volume) {
      this.imaPlayerVolume = volume <= 1 ? volume : volume / 100;
    }

    /**
     * Method to unload the currently loaded ad from the AdsManager and AdContainer. Calling
     * this method requires that a new AdDisplayContainer and AdsManager be created via the
     * ImaPlayer.load() call in order to initiate playback of another ad.
     *
     * AdDisplayContainer.destroy():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdDisplayContainer.destroy
     *
     * AdsManager.destroy():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager.destroy
     */

  }, {
    key: 'unload',
    value: function unload() {
      this.stop();
      this.ad = {};

      if (this.adContainer) {
        this.adContainer.destroy();
        this.adContainer = null;
      }
      if (this.adsManager) {
        this.adsManager.destroy();
        this.adsManager = null;
      }
    }

    /**
     * Method to stop, unload and remove the IMA video element from the DOM. Calling this
     * method requires that the ImaPlayer be re-initialized using the .initialize() method
     * before trying to play a new ad.
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.unload();
      this.imaVideoElement = null;
      this.playerContainerElement = null;
      this.emit(_imaEvents2.default.AdEvent.AD_COMPLETED);
    }

    /**
     * AdError event handler for the Google IMA AdsManager. Publishes an AdEvent.AD_ERROR for
     * listeners to use.
     *
     * AdErrorEvent:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdErrorEvent
     *
     * @param ex {Error|AdErrorEvent}
     */

  }, {
    key: 'onAdError',
    value: function onAdError(ex) {
      var imaErrorCodes = (0, _get2.default)(this, 'google.ima.AdError.ErrorCode', {});
      var error = ex && ex.getError && ex.getError();
      var innerError = error && error.getInnerError && error.getInnerError();
      var innerErrorCode = innerError && innerError.getErrorCode && innerError.getErrorCode();

      if (innerErrorCode === imaErrorCodes.AUTOPLAY_DISALLOWED) {
        this.emit(_imaEvents2.default.AdEvent.AUTOPLAY_DISALLOWED_ERROR, innerError);
        return;
      }
      this.emit(_imaEvents2.default.AdEvent.AD_ERROR, error || ex);
    }
    /**
      * AdLoaded event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_LOADED event,
     * as well as specific events for a video (VideoEvent.AD_LOADED) or audio (AudioEvent.AD_LOADED)
     * ad.
     *
     * Is also responsible for building the ad model that will be passed to registered event listeners
     * for the duration of the ad lifecycle.
     *
     * AdEvent:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdEvent
     *
     * @param adEvent {AdEvent}
     */

  }, {
    key: 'onAdLoaded',
    value: function onAdLoaded(adEvent) {
      try {
        var ad = adEvent.getAd();
        var adData = adEvent.getAdData();
        var contentType = ad.getContentType();
        this.ad = {
          isVideoAd: contentType && contentType.includes('video'),
          adId: (0, _get2.default)(adData, 'adId'),
          creativeId: (0, _get2.default)(adData, 'creativeId'),
          height: ad.getHeight(),
          width: ad.getWidth(),
          clickThroughUrl: adEvent.getAdData().clickThroughUrl
        };
        if (this.ad.isVideoAd) {
          this.emit(_imaEvents2.default.VideoEvent.AD_LOADED, this.ad);
        } else {
          this.emit(_imaEvents2.default.AudioEvent.AD_LOADED, this.ad);
        }
        this.emit(_imaEvents2.default.AdEvent.AD_LOADED, this.ad);
      } catch (ex) {
        this.onAdError(ex);
      }
    }

    /**
     * AdStarted event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_STARTED
     * event, as well as specific events for a video (VideoEvent.AD_STARTED) or audio
     * (AudioEvent.AD_STARTED) ad.
     */

  }, {
    key: 'onAdStarted',
    value: function onAdStarted() {
      if (this.ad.isVideoAd) {
        this.emit(_imaEvents2.default.VideoEvent.AD_STARTED, this.ad);
      } else {
        this.emit(_imaEvents2.default.AudioEvent.AD_STARTED, this.ad);
      }
      this.emit(_imaEvents2.default.AdEvent.AD_STARTED, this.ad);
    }

    /**
     * Event handler for Google IMA AdsManager that is responsible for obtaining any companion ads
     * that are tied to the currently loaded ad. Publishes a generic AdEvent.AD_COMPANIONS_LOADED
     * event, as well as specific events for a video (VideoEvent.AD_COMPANIONS_LOADED) or audio
     * (AudioEvent.AD_COMPANIONS_LOADED) ad.
     *
     * Is also responsible for building the companion ad model that will be passed to registered event
     * listeners for the duration of the ad lifecycle.
     *
     * AdEvent:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdEvent
     *
     * CompanionAdSelectionSettings:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.CompanionAdSelectionSettings
     *
     * AdEvent.getCompanionAds():
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.Ad.getCompanionAds
     *
     * @param adEvent {AdEvent}
     */

  }, {
    key: 'getCompanionAds',
    value: function getCompanionAds(adEvent) {
      try {
        var ad = adEvent.getAd();
        var companionAds = this._getCompanionAdsBySize(ad);
        var companions = companionAds.map(function (companionAd) {
          return {
            height: companionAd.getHeight(),
            width: companionAd.getWidth(),
            content: companionAd.getContent()
          };
        });
        if (this.ad.isVideoAd) {
          this.emit(_imaEvents2.default.VideoEvent.AD_COMPANIONS_LOADED, companions);
        } else {
          this.emit(_imaEvents2.default.AudioEvent.AD_COMPANIONS_LOADED, companions);
        }
        this.emit(_imaEvents2.default.AdEvent.AD_COMPANIONS_LOADED, companions);
      } catch (ex) {
        this.emit(_imaEvents2.default.AdEvent.AD_COMPANIONS_LOAD_ERROR, ex);
      }
    }
  }, {
    key: 'onVolumeChanged',
    value: function onVolumeChanged() {
      try {
        var volume = this.adsManager.getVolume();
        if (this.ad.isVideoAd) {
          this.emit(_imaEvents2.default.VideoEvent.AD_VOLUME_CHANGED, volume);
        } else {
          this.emit(_imaEvents2.default.AudioEvent.AD_VOLUME_CHANGED, volume);
        }
        this.emit(_imaEvents2.default.AdEvent.AD_VOLUME_CHANGED, volume);
      } catch (ex) {
        // noop
      }
    }

    /**
     * AdImpression event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_IMPRESSION
     * event, as well as specific events for a video (VideoEvent.AD_IMPRESSION) or audio
     * (AudioEvent.AD_IMPRESSION) ad.
     */

  }, {
    key: 'onAdImpression',
    value: function onAdImpression() {
      if (this.ad.isVideoAd) {
        this.emit(_imaEvents2.default.VideoEvent.AD_IMPRESSION, this.ad);
      } else {
        this.emit(_imaEvents2.default.AudioEvent.AD_IMPRESSION, this.ad);
      }
      this.emit(_imaEvents2.default.AdEvent.AD_IMPRESSION, this.ad);
    }

    /**
     * AdImpression event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_PROGRESS
     * event, as well as specific events for a video (VideoEvent.AD_PROGRESS) or audio
     * (AudioEvent.AD_PROGRESS) ad.
     *
     * AdEvent:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdEvent
     *
     * AdProgressData:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdProgressData
     *
     * @param adEvent {AdEvent}
     */

  }, {
    key: 'onAdProgress',
    value: function onAdProgress(adEvent) {
      try {
        var ad = adEvent.getAdData();
        var remainingTime = this.adsManager.getRemainingTime();
        var duration = ad.duration;
        var position = (duration || 0) - (remainingTime || 0);
        if (this.ad.isVideoAd) {
          this.emit(_imaEvents2.default.VideoEvent.AD_PROGRESS, { duration: duration, position: position });
        } else {
          this.emit(_imaEvents2.default.AudioEvent.AD_PROGRESS, { duration: duration, position: position });
        }
        this.emit(_imaEvents2.default.AdEvent.AD_PROGRESS, { duration: duration, position: position });
      } catch (ex) {
        // noop
      }
    }

    /**
     * AdPaused event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_PAUSED
     * event, as well as specific events for a video (VideoEvent.AD_PAUSED) or audio
     * (AudioEvent.AD_PAUSED) ad.
     */

  }, {
    key: 'onAdPaused',
    value: function onAdPaused() {
      if (this.ad.isVideoAd) {
        this.emit(_imaEvents2.default.VideoEvent.AD_PAUSED, this.ad);
      } else {
        this.emit(_imaEvents2.default.AudioEvent.AD_PAUSED, this.ad);
      }
      this.emit(_imaEvents2.default.AdEvent.AD_PAUSED, this.ad);
    }

    /**
     * AdResumed event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_RESUMED
     * event, as well as specific events for a video (VideoEvent.AD_RESUMED) or audio
     * (AudioEvent.AD_RESUMED) ad.
     */

  }, {
    key: 'onAdResumed',
    value: function onAdResumed() {
      if (this.ad.isVideoAd) {
        this.emit(_imaEvents2.default.VideoEvent.AD_RESUMED, this.ad);
      } else {
        this.emit(_imaEvents2.default.AudioEvent.AD_RESUMED, this.ad);
      }
      this.emit(_imaEvents2.default.AdEvent.AD_RESUMED, this.ad);
    }

    /**
     * AdComplete event handler for Google IMA AdsManager. Publishes a generic AdEvent.AD_COMPLETED
     * event, as well as specific events for a video (VideoEvent.AD_COMPLETED) or audio
     * (AudioEvent.AD_COMPLETED) ad.
     */

  }, {
    key: 'onAdComplete',
    value: function onAdComplete() {
      if (this.ad.isVideoAd) {
        this.emit(_imaEvents2.default.VideoEvent.AD_COMPLETED, this.ad);
      } else {
        this.emit(_imaEvents2.default.AudioEvent.AD_COMPLETED, this.ad);
      }
      this.emit(_imaEvents2.default.AdEvent.AD_COMPLETED, this.ad);
    }
  }, {
    key: '_getCompanionAdsBySize',
    value: function _getCompanionAdsBySize(ad) {
      var ima = this.google.ima;

      var selectionCriteria = new ima.CompanionAdSelectionSettings();
      selectionCriteria.resourceType = ima.CompanionAdSelectionSettings.ResourceType.ALL;
      selectionCriteria.creativeType = ima.CompanionAdSelectionSettings.CreativeType.ALL;
      selectionCriteria.sizeCriteria = ima.CompanionAdSelectionSettings.SizeCriteria.SELECT_EXACT_MATCH;

      var companionAds = [];
      (0, _forEach2.default)(COMPANION_AD_SIZES, function (dimensions) {
        var width = dimensions.width,
            height = dimensions.height;

        var companions = ad.getCompanionAds(width, height, selectionCriteria);
        if (!companions) {
          return;
        }
        companionAds = companionAds.concat(companions);
      });
      return companionAds;
    }
  }]);

  return ImaPlayer;
}(_ImaApi3.default);

exports.default = ImaPlayer;